const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/ErrorMsg/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        'unknown-error': 'Ein unbekannter Fehler ist aufgetreten',
        'missing-token-in-response': 'Die Sitzung konnte nicht gestartet werden',
        'missing-patnr-in-response': 'Die Patientennummer konnte nicht ermittelt werden',
        'missing-workid-in-response': 'Die Aufgebots-ID konnte nicht ermittelt werden',
        exception: 'Ein Ausnahmefehler ist aufgetreten',
        'bad-route': 'Der Server wurde mit einer unbekannten Route angesprochen',
        'bad-backend-to-backend-response': 'Der Server kann nicht mit einem bestimmten anderen Server kommunizieren',
        'could-not-fetch-kisapi-token': 'Der Server hat kein Token für einen bestimmten anderen Server bekommen',
        'failed-to-call-kisapi-endpoint': 'Der Server kann den Service eines bestimmten anderen Servers nicht aufrufen',
        'kisapi-endpoint-returned-with-fail':
            'Der Server hat von einem bestimmten anderen Server einen Fehler erhalten',
        'missing-mandatory-args': 'Ein Service des Servers wurde mit fehlenden Argumenten aufgerufen',
        'workitem-not-found':
            'Es wurde kein Aufgebot mit diesem Code gefunden. Bitte prüfen Sie, ob Sie den Code richtig abgeschrieben haben.',
        'workitem-missing-data':
            'Das Aufgebot, das zu diesem Code passt, ist unvollständig hinterlegt. Sie können sich mit diesem Code nicht anmelden.',
        'patient-missing-data':
            'Sie sind entweder noch nicht im System dieses Spitals als Patient erfasst, oder es fehlen wichtige Angaben. Sie können sich mit diesem Code nicht anmelden.',
        'invitation-code-not-unique':
            'Es wurden mehrere Aufgebote gefunden mit diesem Code. Sie können sich nicht anmelden.',
        'cannot-determine-mobile-number':
            'Ihre Mobiltelefonnummer ist nicht im System erfasst oder ist nicht mehr gültig. Das System kann Ihnen kein SMS senden. Sie können sich nicht anmelden.',
        'failed-to-send-text-to-mobile':
            'Beim Verschicken des SMS ist ein Fehler aufgetreten. Sie können sich im Moment nicht anmelden.',
        'sms-code-expired': 'Der eingegebene SMS-Code ist nicht mehr gültig.',
        'sms-code-wrong': 'Der eingegebene SMS-Code ist falsch.',
        'sms-code-too-many-attempts': 'Sie haben die maximale Anzahl an Versuchen erreicht.',
        'too-early-for-another-sms': 'Das SMS konnte nicht versendet werden. Bitte warten Sie einige Minuten.',
        'patapi-token-invalid-or-expired':
            'Der Server kann nicht angesprochen werden, weil ein Schlüssel ungültig oder abgelaufen ist',
        'kisapi-endpoint-access-denied': 'Zugriff verweigert für ein Service auf dem Server',
    },
    __RELATIVE_SOURCE_FILE__
);
